import { Stack } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { GhostButton } from '@ardoq/button';
import { ChevronDownIcon, ChevronUpIcon } from '@ardoq/icons';
import { header1 } from '@ardoq/typography';

const TimeUnit = styled.span`
  ${header1};
  color: ${colors.textModerate};
`;

export const TimeSeparator = styled(TimeUnit).attrs({ children: ':' })`
  color: ${colors.iconAction};
`;

type TimeUpDownProps = {
  onUpClick?: () => void;
  isUpDisabled?: boolean;
  onDownClick?: () => void;
  isDownDisabled?: boolean;
  value: string;
};

export const TimeUpDown = ({
  onUpClick,
  isUpDisabled,
  onDownClick,
  isDownDisabled,
  value,
}: TimeUpDownProps) => (
  <Stack gap="small" align="center">
    <GhostButton onClick={onUpClick} isDisabled={isUpDisabled}>
      <ChevronUpIcon />
    </GhostButton>
    <TimeUnit>{value}</TimeUnit>
    <GhostButton onClick={onDownClick} isDisabled={isDownDisabled}>
      <ChevronDownIcon />
    </GhostButton>
  </Stack>
);
